import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="bg-white w-full">
      {/* Main Footer Section */}
      <div className="border-solid border-t border-gray-200">
        <div className="mx-auto">
          <div className="w-full max-w-screen-2xl mx-auto px-2 lg:px-4 flex flex-col lg:flex-row items-center gap-4 lg:gap-8 pt-4">
            {/* Logo Section */}
            <div className="w-full lg:w-[20%] flex justify-center lg:justify-start">
              <Link to="https://credentia.com/">
                <img 
                  height="65" 
                  className="min-h-[55px] max-h-[55px] max-w-[200px]" 
                  src={`${process.env.PUBLIC_URL}/icon.svg`}
                  alt="Credentia"
                />
              </Link>
            </div>

            {/* Certification Badges Section */}
            <div className="w-full lg:w-[60%] flex flex-wrap items-center justify-center">
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 rounded-lg flex items-center justify-center">
                  <img src={`https://credentia.com/storage/coppa.svg`} alt="COPPA" />
                </div>
              </div>
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 rounded-lg flex items-center justify-center">
                  <img src={`https://credentia.com/storage/coppa-&-ferpa.svg`} alt="FERPA" />
                </div>
              </div>
              <div className="flex flex-col items-center">
                <div className="w-16 h-24 rounded-lg flex items-center justify-center">
                  <img src={`https://credentia.com/storage/iso-2.svg`} alt="ISO 27001:2019" />
                </div>
              </div>
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 rounded-lg flex items-center justify-center">
                  <img src={`https://credentia.com/storage/gdpr-ready.svg`} alt="GDPR Ready" />
                </div>
              </div>
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 rounded-lg flex items-center justify-center">
                  <img src={`https://credentia.com/storage/iso.svg`} alt="ISO" />
                </div>
              </div>
              {/* SOC 2 Type II Badge */}
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 rounded-lg flex items-center justify-center">
                  <img src={`https://credentia.com/storage/pci.svg`} alt="PCI" />
                </div>
              </div>
              {/* COPPA Badge */}
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 rounded-lg flex items-center justify-center">
                  <img src={`https://credentia.com/storage/soc2.svg`} alt="SOC 2 Type II" />
                </div>
              </div>
            </div>

            {/* Social Media Section */}
            <div className="w-full lg:w-[20%] flex justify-center lg:justify-end">
              <a 
                className="mr-[1rem] rounded-md border-[1px] flex justify-center items-center px-2 py-2" 
                href="https://www.linkedin.com/company/credentia-services/" 
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                style={{ color: '#486284', borderColor: '' }}
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
              <a 
                className="mr-[1rem] rounded-md border-[1px] flex justify-center items-center px-2 py-2" 
                href="https://twitter.com/getcredentia" 
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter"
                style={{ color: '#486284', borderColor: '' }}
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                </svg>
              </a>
              <a 
                className="rounded-md border-[1px] flex justify-center items-center px-2 py-2" 
                href="https://www.instagram.com/credentianurseaide/" 
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                style={{ color: '#486284', borderColor: '' }}
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Legal Text Section */}
      <div className="bg-white py-2">
        <div className="container mx-auto px-4 text-center">
          <p className="text-[#486284] text-md">
            Credentia and the Credentia logo mark are trademarks of Credentia Nurse Aide LLC
          </p>
          
          <div className="flex flex-wrap justify-center items-center gap-2 text-sm text-[#486284]">
            <Link className="underline" to="https://credentia.com/about-us/privacy-policy">Privacy Policy</Link>
            <span className="text-[#486284]">|</span>
            <Link className="underline" to="https://credentia.com/about-us/disclaimer">Disclaimer</Link>
            <span className="text-[#486284]">|</span>
            <Link className="underline" to="https://credentia.com/about-us/terms-and-conditions">Terms and Conditions</Link>
            <span className="text-[#486284]">|</span>
            <Link className="underline" to="https://credentia.com/about-us/data-privacy">Data Privacy</Link>
            <span className="text-[#486284]">|</span>
            <Link className="underline" to="https://credentia.com/about-us/fcc">FCC</Link>
            <span className="text-[#486284]">|</span>
            <a className="underline" href="https://status.credentia.com/" target="_blank" rel="noopener noreferrer">System Status</a>
            <span className="text-[#486284]">|</span>
            <Link className="underline" to="https://credentia.com/sitemap">Sitemap</Link>
          </div>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="bg-blue-100 mt-8 py-3">
        <div className="container mx-auto px-4 text-center">
          <p className="text-sm text-[#486284]">© 2007 - {new Date().getFullYear()} All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
